export const FIELD_DESCRIPTION_MAX_LENGTH = 2000;

/** Пустая строка → null; обрезает до 2000 символов. */
export function serializeFieldDescription(raw: unknown): string | null {
  if (raw == null) return null;
  const text = String(raw).trim().slice(0, FIELD_DESCRIPTION_MAX_LENGTH);
  return text || null;
}

export function readFieldDescription(raw: unknown): string {
  return serializeFieldDescription(raw) ?? "";
}
